var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('b-tooltip',{attrs:{"label":"Share Report Link","position":"is-bottom"}},[_c('a',{attrs:{"href":"#_","label":""},on:{"click":_vm.cardReportLink}},[_c('b-icon',{attrs:{"pack":"fas","icon":"share-alt-square"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }